import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import { ButtonVariant } from "cms/components/Button/Button.styles";
import Text from "cms/components/Text";

import {
  Container,
  Content,
  Link,
  Message,
} from "./EnterpriseShoutoutBlock.styles";

export interface EnterpriseShoutoutBlockProps
  extends Queries.SanityEnterpriseShoutoutBlock {}

const EnterpriseShoutoutBlock: React.FC<EnterpriseShoutoutBlockProps> = ({
  headline,
  button,
}) => (
  <Container>
    <Content>
      <Message>
        <Text variant="H3" as="h3" textAlign="center" color="#fff">
          {headline}
        </Text>
        {button?.url && button.label && (
          <Link href={button.url}>
            <Button
              label={button.label}
              // variant={button.variant as ButtonVariant}
              variant="primary"
            />
          </Link>
        )}
      </Message>
    </Content>
  </Container>
);

export const query = graphql`
  fragment EnterpriseShoutoutBlock on SanityEnterpriseShoutoutBlock {
    _key
    _type
    headline
    button {
      variant
      label
      url
    }
  }
`;

export default EnterpriseShoutoutBlock;
